module.exports = __webpack_public_path__ + "static/fun-time/games/page010_game0/audio//6_bear.mp3";